import React from "react";
import "./HomeGoalsView.css";

const HomeGoalsView = () => {
    return (
        <div class="container-goals">
            <div class="box">Achieving goals</div>
            <div class="box">Planning</div>
            <div class="center-box">Entertainment and fun</div>
            <div class="box">Achieving goals</div>
            <div class="box">Hobby</div>
        </div>
    );
};

export default HomeGoalsView;